import {spacing} from '@/theme/spacing'
import {
    ModalOverlay as AriaModalOverlay,
    Modal as AriaModal,
    Dialog as AriaDialog,
} from 'react-aria-components'
import styled from 'styled-components'

export const ModalMaxHeight = '90vh'
export const ModalMaxWidth = '90vw'

export const ModalOverlay = styled(AriaModalOverlay)`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    background-color: rgba(0, 0, 0, 0.25);

    display: flex;
    align-items: center;
    justify-content: center;

    // This is the number use for react-aria popover.
    // Our navigation bar has a z-index of 1000.
    // So we should just make sure this number is higher than
    // that. But we should find a way to ditch z-index on the navbar.
    z-index: 2000;

    height: var(--visual-viewport-height);
    width: 100%;

    /* Animation for fade in/out */
    &[data-entering] {
        animation: fade-in 200ms ease-out;
    }

    &[data-exiting] {
        animation: fade-out 150ms ease-in;
    }

    @keyframes fade-in {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }

    @keyframes fade-out {
        from {
            opacity: 1;
        }
        to {
            opacity: 0;
        }
    }
`

export const Modal = styled(AriaModal)<{size?: string}>`
    display: flex;
    justify-content: center;

    max-height: ${ModalMaxHeight};
    max-width: ${ModalMaxWidth};
    ${({size}) => {
        if (size === 'sm') {
            return 'max-width: 420px;'
        }
        if (size === 'md') {
            return 'max-width: 640px;'
        }
        if (size === 'lg') {
            return 'max-width: 800px;'
        }
        if (size === 'xl') {
            return 'max-width: 1024px;'
        }
        return ''
    }}
`

export const Dialog = styled(AriaDialog)`
    display: flex;
    flex: 1 0 0;
    border-radius: ${spacing(2)};
    width: 100%;
`

// Use this to have a basic white background with
// sensible width and padding
export const BaseModalContainer = styled.div`
    background-color: white;
    padding: 12px;
    width: max-content;
    min-width: 300px;
    max-width: 96vw;
    border-radius: 4px;
`
